"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ScreenShareKnockItem = require("./ScreenShareKnockItem");
Object.keys(_ScreenShareKnockItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ScreenShareKnockItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ScreenShareKnockItem[key];
    }
  });
});